enum Language {
  EN = 'en',
  NL = 'nl',
}

export default Language;
